module.exports = __webpack_public_path__ + "img/65.a1217f6b.jpg";